import { Injectable } from "@angular/core";
import { EndSessionConfigurationService } from "./end-session/end-session-configuration.service";
import { ConfigurationModule } from "../../configuration.module";
import { ReleaseLicenseConfigurationService } from "./release-license/release-license-configuration.service";
import { LogoutConfiguration } from "./logout-configuration";

@Injectable({
  providedIn: ConfigurationModule,
})
export class LogoutConfigurationService {
  get configuration(): LogoutConfiguration {
    return {
      enabled: this.enabled,
      returnTo: this.returnTo,
    };
  }

  returnTo;

  enabled;

  constructor(
    private endSessionConfigurationService: EndSessionConfigurationService,
    private releaseLicenseConfigurationService: ReleaseLicenseConfigurationService
  ) {}

  loadConfiguration(configuration) {
    this.loadEndSessionConfiguration(configuration.endSession);
    this.loadReleaseLicenseConfiguration(configuration.releaseLicense);
    this.returnTo = configuration.returnTo;
    this.enabled = true;
  }

  loadEndSessionConfiguration(configuration) {
    return this.endSessionConfigurationService.loadConfiguration(configuration);
  }

  loadReleaseLicenseConfiguration(configuration) {
    return this.releaseLicenseConfigurationService.loadConfiguration(
      configuration
    );
  }
}
